export default "__VITE_ASSET__BEwnDan0__"